import { useCallback, useState } from 'react';

import { isNotDefined } from 'utils/ramda';

/**
 * A hook for observing the size of an element
 *
 * Needs to provide  {@link HTMLElement}-related type for the containerRef
 *
 * @returns a tuple of the containerRef and the {@link DOMRect} object providing information about the size of the ref element
 * @example
 * ```tsx
 * const [containerRef, containerSize] = useElementSize<HTMLDivElement>();
 * ```
 **/
function useElementSize<T extends HTMLElement>() {
  const [boundingClientRect, setBoundingClientRect] = useState<DOMRect>({} as DOMRect);

  const nodeCB = useCallback((node: T) => {
    if (isNotDefined(node)) return;

    setBoundingClientRect(node.getBoundingClientRect());
  }, []);

  return [nodeCB, boundingClientRect] as const;
}

export default useElementSize;
